// extracted by mini-css-extract-plugin
export default {"wrap":"EG-z","articleImagesWrap":"FG-z","articleImage":"GG-z","singleImage":"HG-z"};